import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Button, Chip } from "@components/controls/Button"
import { ResultListMode } from "@components/layout/ResultList"
import { RouteFlipped } from "@components/motion/RouteFlipped"
import { IconCaretRight } from "@components/svg/Icons"
import { getDateRange } from "@utils/dates"
import { Link } from "eddev/routing"
import { useMemo } from "react"
import { EventCardFragment } from "../../types.graphql"

type Props = EventCardFragment & {
  mode?: ResultListMode
  ctaLabel?: string
}

export function EventCard(props: Props) {
  const range = useMemo(() => {
    return getDateRange(props.dates.flatMap((d) => [d.startDate, d.endDate]).filter((d): d is string => !!d))
  }, [props.dates])

  let ctaLabel = props.ctaLabel ?? "Details"

  if (props.mode === "row") {
    return (
      <Link href={props.uri} className="grid-auto @container grid-flow-col border-t pt-4 pb-4 text-pretty">
        <div className="col-span-3 order-1 @lg:order-none @lg:col-span-1">
          <RouteFlipped flipId={props.id!}>
            <ResponsiveImage {...props.hero?.image} />
          </RouteFlipped>
        </div>
        <div className="col-span-9 @lg:col-span-4">
          <div className="type-title-xs-medium @[200px]:type-title-s-medium antialiased">{props.title}</div>
          <div className="type-title-xs-roman @[200px]:type-title-s-light">{range}</div>
          <div className="flex flex-wrap gap-1 pt-1">
            {props.branches?.nodes.map((branch, i) => (
              <Chip key={i}>{branch.shortName}</Chip>
            ))}
          </div>
        </div>
        <div className="hidden @lg:block @lg:col-span-5">
          <div className="type-body-s-roman line-clamp-3">{props.shortDescription}</div>
        </div>
        <div className="hidden @lg:flex justify-end @lg:col-span-2">
          <Button variant="outline" rightIcon={<IconCaretRight />}>
            {ctaLabel}
          </Button>
        </div>
      </Link>
    )
  } else {
    return (
      <Link href={props.uri} className="block mb-7 @container text-pretty">
        <RouteFlipped flipId={props.id!}>
          <ResponsiveImage {...props.hero?.image} />
        </RouteFlipped>
        <div className="stack-y-1 pt-3">
          <div className="stack-y-0">
            <div className="type-title-xs-medium @[200px]:type-title-s-medium antialiased">{props.title}</div>
            <div className="type-title-xs-roman @[200px]:type-title-s-light">{range}</div>
          </div>
          <div className="flex flex-wrap gap-1">
            {props.branches?.nodes.map((branch, i) => (
              <Chip key={i}>{branch.shortName}</Chip>
            ))}
          </div>
          <div className="pt-1 type-body-s-roman line-clamp-2">{props.shortDescription}</div>
        </div>
      </Link>
    )
  }
}
